import { inject, Injectable, signal } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { catchError, filter, tap, throwError } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  private flags = signal<Record<string, boolean> | null>(null);
  readonly flags$ = toObservable(this.flags).pipe(filter(flags => !!flags));
  private http = inject(HttpClientService);

  loadFlags(){
      return this.http.get<Record<string, boolean>>(`FeatureFlags`)
      .pipe(
        tap(flags => this.flags.set({...flags})),
        tap(() => this.flags),
        catchError((err) => {
          this.flags.set({});
          return throwError(()=> err)
        })
      )
      .subscribe();
  }
}
